import React from 'react';

const testimonials = [
  {
    quote:
      "They always take the time to be prepared. This gives the people I refer a comfort level they can't find anywhere else.",
    author: 'J.F.',
    location: 'California',
    initials: 'JF',
  },
  {
    quote:
      'I have never had a second thought. Very fair and ethical group that truly cares about the outcomes.',
    author: 'M.B.',
    location: 'Kansas',
    initials: 'MB',
  },
  {
    quote:
      "They treat each referral with care and respect. That's rare in this industry — and it makes all the difference.",
    author: 'I.C.',
    location: 'New York',
    initials: 'IC',
  },
  {
    quote:
      "They really know what they are doing. I wouldn't work with anyone else. Consistent results every single time.",
    author: 'E.I.',
    location: 'Arizona',
    initials: 'EI',
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-700 rounded-full filter blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-600/20 border border-blue-500/30 text-blue-300 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4">
            Trusted by Professionals
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5">
            What Our <strong>Partners Say</strong>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed">
            Brokers who have referred thousands of business owners trust us to deliver results
            with integrity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:bg-white/10 hover:border-blue-500/30 transition-all duration-300"
            >
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>

              <p className="text-gray-300 leading-relaxed mb-6 text-sm">
                &ldquo;{testimonial.quote}&rdquo;
              </p>

              <div className="flex items-center gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-white text-sm font-bold">
                  {testimonial.initials}
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">{testimonial.author}</div>
                  <div className="text-gray-500 text-xs">{testimonial.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <div className="text-3xl font-bold text-blue-400 mb-1">15+</div>
            <div className="text-white font-semibold text-sm mb-1">Years Experience</div>
            <div className="text-gray-500 text-xs">Trusted by brokers nationwide</div>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <div className="text-3xl font-bold text-blue-400 mb-1">100%</div>
            <div className="text-white font-semibold text-sm mb-1">Confidential</div>
            <div className="text-gray-500 text-xs">Your referrals are always protected</div>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <div className="text-3xl font-bold text-blue-400 mb-1">Fast</div>
            <div className="text-white font-semibold text-sm mb-1">Case Confirmation</div>
            <div className="text-gray-500 text-xs">Instant status on every referral</div>
          </div>
        </div>
      </div>
    </section>
  );
}
